import 'react-quill/dist/quill.snow.css';

import { AppBar, Button, Card, CircularProgress, Grid, Tab, Tabs } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { useCallback } from 'react';
import { Link, useHistory, useParams } from 'react-router-dom';
import Swal from 'sweetalert2';

import { BackdropLoading } from '../../../components';
import { delDataSHE, getDetailDataSHE } from '../../../redux/actions/SHEActions';

const DetailSHE = () => {
    const { id } = useParams();
    const history = useHistory();
    const [loading, setLoading] = useState(false);
    const [showLoading, setShowLoading] = useState(false);
    const [tabActive, setTabActive] = useState(0)
    const [params, setParams] = useState({
        thumbnail: '',
        title_id: '',
        title_en: '',
        desc_id: '',
        desc_en: '',
        cat: '',
        meta_title_id: '',
        meta_title_en: '',
        meta_desc_id: '',
        meta_desc_en: '',
    });
    const showAlert = useCallback((text, success) => {
        Swal.fire({
            title: success ? 'Berhasil' : 'Oopss!',
            text: text,
            imageUrl: `/assets/images/icons/${
                success ? 'ic_success' : 'ic_error'
            }.svg`,
            imageWidth: 92,
            imageHeight: 92,
            confirmButtonText: 'Ok',
            confirmButtonColor: '#0083E2'
        }).then(res => {
            if(res.isConfirmed && success){
                history.goBack();
            }
        })
    }, [history]);
    const getData = useCallback(() => {
        setLoading(true);
        getDetailDataSHE(id)
            .then((res) => {
                let data = res.data?.data;
                if (Object.keys(data).length > 0) {
                    setParams((pref) => ({
                        ...pref,
                        thumbnail: data?.thumbnail,
                        title_id: data?.title_id,
                        title_en: data?.title_en,
                        desc_id: data?.desc_id,
                        desc_en: data?.desc_en,
                        cat: data?.cat,
                        meta_title_id: data?.meta_title_id,
                        meta_title_en: data?.meta_title_en,
                        meta_desc_id: data?.meta_desc_id,
                        meta_desc_en: data?.meta_desc_en,
                    }));
                } else {
                    showAlert(
                        'Gagal mengambil detail data aktifitas she, coba beberapa saat lagi',
                        false
                    );
                }
                setLoading(false);
            })
            .catch((err) => {
                let error = err?.response?.data;
                showAlert(
                    Array.isArray(error?.data)
                        ? error?.data[0]
                        : 'Gagal mengambil detail data aktifitas she, coba beberapa saat lagi',
                    false
                );
                setLoading(false);
            });
    }, [id, showAlert]);
    useEffect(() => {
        setParams((pref) => ({
            ...pref,
            mg_code: id
        }));
        getData();
    }, [getData, id]);

    const handleDelete = (code, nama) => {
        Swal.fire({
            title: 'Konfirmasi Hapus',
            text: 'Apakah anda yakin ingin menghapus data ' + nama,
            imageUrl: `/assets/images/icons/ic_delete.svg`,
            imageWidth: 92,
            imageHeight: 92,
            confirmButtonText: 'Hapus',
            confirmButtonColor: '#FD6D5D',
            showCancelButton: true,
            cancelButtonText: 'Batal',
            cancelButtonColor: '#0083E2',
            reverseButtons: true
        }).then((res) => {
            if (res.isConfirmed) {
                sendDelete(code);
            }
        });
    };

    const sendDelete = (code) => {
        setShowLoading(true);
        delDataSHE(code)
            .then(() => {
                setShowLoading(false);
                showAlert('Berhasil menghapus data', true);
            })
            .catch((err) => {
                let error = err?.response?.data;
                setShowLoading(false);
                showAlert(
                    Array.isArray(error?.data)
                        ? error?.data[0]
                        : 'Gagal menghapus data, coba beberapa saat lagi',
                    false
                );
            });
    };
    return (
        <div className="m-sm-30">
            <Grid container spacing={4} justifyContent="center">
                <Grid item xs={11} md={9}>
                    <h3 className="fw-bold m-0">Detail Aktifitas SHE</h3>
                </Grid>
                <Grid item xs={11} md={3}>
                    <Grid container spacing={2}>
                        <Grid item xs={6}>
                            <Link to={`/data_she/edit/${id}`} className="btn btn-outline-primary flex items-center border-radius-0 w-full">
                                <img
                                    src="/assets/images/icons/ic_action_edit.svg"
                                    alt="icon edit"
                                />
                                <span className="pl-4">
                                    {' '}
                                    Edit{' '}
                                </span>
                            </Link>
                        </Grid>
                        <Grid item xs={6}>
                            <Button onClick={() => handleDelete(params.slug, params.title_id)} variant="outlined" className='btn-outline-danger border-danger text-danger w-full'>
                                <img
                                    src="/assets/images/icons/ic_action_delete.svg"
                                    alt="icon delete"
                                />
                                <span className="pl-4">
                                    {' '}
                                    Delete{' '}
                                </span>
                            </Button>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={11} md={12}>
                    <Card elevation={0} className="py-5 px-6 border-radius-0 ">
                        {loading ? (
                            <div className="text-center">
                                <CircularProgress color="primary" size={35} />
                            </div>
                        ) : (
                            <Grid container spacing={2} justifyContent="center">
                                <Grid item xs={12} md={8}>
                                    <AppBar position="static"  elevation={0} color="inherit">
                                        <Tabs indicatorColor='primary' textColor="primary" value={tabActive} onChange={(e, val)=>setTabActive(val)} variant="fullWidth">
                                            <Tab label="Indonesia" />
                                            <Tab label="Inggris" />
                                        </Tabs>
                                    </AppBar>
                                </Grid>
                                {
                                    tabActive === 0 ?
                                <Grid item xs={12} md={10} className="pt-5">
                                    <h2 className='font-semibold mb-6'>{params.title_id}</h2>
                                    <img src={params.thumbnail} alt={params.title_id} className="mb-8 w-full " />
                                    <div className="ql-editor" dangerouslySetInnerHTML={{__html: params.desc_id}}></div>
                                </Grid>
                                :
                                <Grid item xs={12} md={10} className="pt-5">
                                    <h2 className='font-semibold mb-6'>{params.title_en}</h2>
                                    <img src={params.thumbnail} alt={params.title_en} className="mb-8 w-full " />
                                    <div className="ql-editor" dangerouslySetInnerHTML={{__html: params.desc_en}}></div>
                                </Grid>
                                }
                            </Grid>
                        )}
                    </Card>
                </Grid>
            </Grid>
            <BackdropLoading open={showLoading} />
        </div>
    );
};

export default DetailSHE;
